module.exports = __webpack_public_path__ + "media/images/blog/sample-kodawari2-cb02ec0e1115bb6fbd38f96fc817281f.jpg";